import { Fragment } from 'react'
import { useIntl } from 'react-intl'
import messages from '../translations'

import BookingDetailsCardExtras from './components/BookingDetailsCardExtras'
import BookingDetailsCardAccomodation from './components/BookingDetailsCardAccomodation'
import BookingDetailsPackage from './components/BookingDetailsPackage'

const BookingDetailsCardMain = ({ order, guestsInRoom, onCouponRemove, isCheckout }) => {
  const intl = useIntl()
  const {
    currency,
    itemsMandatory,
    itemsMandatoryTotal,
    itemsExtra,
    itemsExtraTotal,
    totalForOptions,
    options,
    appliedCoupon,
    itemsExtraLegend,
  } = order

  return (
    <Fragment>
      {order.shopKind === 20 && (
        <BookingDetailsCardAccomodation order={order} />
      )}
      <div className='price-pan'>
        {order.shopKind === 10 && (
          <BookingDetailsCardAccomodation order={order} isCheckout={isCheckout} />
        )}
        <BookingDetailsPackage order={order} guestsInRoom={guestsInRoom} isCheckout={isCheckout} />
      </div>

      {!!itemsMandatory && !!itemsMandatory.length && (
        <BookingDetailsCardExtras
          showQuantity
          showPrice
          title={intl.formatMessage(messages.mandatorySurcharges)}
          currency={currency}
          items={itemsMandatory}
          footerTitle={intl.formatMessage(messages.totalPriceForMandatory)}
          totalAmount={itemsMandatoryTotal}
        />
      )}

      {!!itemsExtra && !!itemsExtra.length && (
        <BookingDetailsCardExtras
          showQuantity
          showPrice
          title={intl.formatMessage(messages.extras)}
          currency={currency}
          items={itemsExtra}
          footerTitle={intl.formatMessage(messages.totalPriceForExtras)}
          totalAmount={itemsExtraTotal}
          itemsExtraLegend={itemsExtraLegend}
        />
      )}

      {!!options && !!options.length && (
        <BookingDetailsCardExtras
          title={intl.formatMessage(messages.options)}
          currency={currency}
          items={options}
          footerTitle={intl.formatMessage(messages.totalPriceForOptions)}
          totalAmount={totalForOptions}
        />
      )}

      {appliedCoupon && (
        <BookingDetailsCardExtras
          title={intl.formatMessage(messages.discount)}
          currency={currency}
          isCoupon
          items={[appliedCoupon]}
          footerTitle={intl.formatMessage(messages.totalPriceForDiscounts)}
          onCouponRemove={onCouponRemove}
        />
      )}
    </Fragment>
  )
}

export default BookingDetailsCardMain
